import { render, staticRenderFns } from "./oceanfileDialog.vue?vue&type=template&id=54057358&scoped=true"
import script from "./oceanfileDialog.vue?vue&type=script&lang=js"
export * from "./oceanfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54057358",
  null
  
)

export default component.exports